import { reactive, ref, toRaw } from "vue";
import {
  firstCreateInfoWindow,
  CreateEditAndDetail,
} from "../testPathComponents/createInfoWindow.js";

export function initializePolyAndLine(
  CoveringTool,
  map,
  showModal,
  showDetailModal,
  polyEditor,
  Covering,
  modalForm,
  sourcePolygon,
  findIndex,
  polylineEditor,
  targetPoly
) {
  //   let targetPoly = ref([]); // 保存编辑前的原始坐标点

  const initializeData = () => {
    // console.log(CoveringTool.value,'23232323232323232');
    let target = []; // 覆盖物的坐标集合
    if(CoveringTool.value.className=="Overlay.Polygon"){

      CoveringTool.value.getPath()[0].forEach((item) => {
        // console.log(item);
        target.push({ lng: item.lng, lat: item.lat });
      });
    }else{
      CoveringTool.value.getPath().forEach((item) => {
        // console.log(item);
        target.push({ lng: item.lng, lat: item.lat });
      });
    }
  

    // 所绘制区域右键的点击事件
    CoveringTool.value.on("click", (i) => {
      console.log(i.target);
      // 绘制框的infowindow
      let editAndDetail = editAndDetailInfoWindow(
        target[target.length - 1]
        // CoveringTool.value
      );
      editAndDetail.open(map.value);
      // 右键绘制框的编辑事件
      let polyEdit = document.getElementById("edit-right-btn");
      polyEdit.addEventListener("click", () => {
        // 编辑框的modal
        showModal("编辑", [], i.target);

        targetPoly.value = []; // 原始坐标数据初始化为空
        i.target
          .getPath()
          .forEach((item) => targetPoly.value.push([item.lng, item.lat])); // 存储原始框的坐标数据
        console.log(targetPoly.value);
        map.value.remove(editAndDetail); // 关闭infowindow
        console.log(i.target);

        // if (i.target.className === "Overlay.Polygon") {
        //   createPolyEditor(i.target); // 框编辑
        // } else {
        //   createPolyLine(i.target); // 线编辑
        // }
        
      });

      // 右键绘制框的详情事件
      let polyDetail = document.getElementById("detail-right-btn");
      polyDetail.addEventListener("click", () => {
        // 编辑框的modal
        showDetailModal(i.target);
        map.value.remove(editAndDetail); // 关闭infowindow
        // console.log(ext_id.value);
      });
    });
  };

  // 创建多边形编辑器
  const createPolyEditor = (overlay) => {
    // 实例化编辑对象
    polyEditor.value = new window.AMap.PolyEditor(map.value, overlay);
    // 添加编辑吸附的框
    polyEditor.value.addAdsorbPolygons(Covering.value);
    // 开始编辑
    polyEditor.value.open();
    // 调整节点事件
    polyEditor.value.on("adjust", (e) => {
      console.log(e.target._opts.path);
      editPolygon();
    });
    // 增加节点事件
    polyEditor.value.on("addnode", (e) => {
      console.log(e.target._opts.path);
      editPolygon();
    });
    // 删除节点事件
    polyEditor.value.on("removenode", (e) => {
      console.log(e.target._opts.path);
      editPolygon();
    });
  };

  // 框编辑和编辑的坐标处理
  const editPolygon = (overlay) => {
    sourcePolygon.value = polyEditor.value.getTarget();

    // 改变坐标
    dataSouce();

    console.log(sourcePolygon.value._opts.path);
    // console.log(modalForm.value);
  };

  // 保存框编辑
  const polygonSave = () => {
    console.log(sourcePolygon.value);
    polyEditor.value ? polyEditor.value.close() : null;

    dataSouce();
    sourcePolygon.value = null;
  };

  // 恢复框编辑前的状态
  const polygonReset = () => {
    console.log(sourcePolygon.value);
    polyEditor.value ? polyEditor.value.close() : null;

    sourcePolygon.value
      ? sourcePolygon.value.setPath(toRaw(targetPoly.value))
      : modalForm.value[findIndex.value].coords;
    //   数据赋值
    console.log(modalForm.value[findIndex.value].coords);
    console.log(modalForm.value);

    dataSouce();
    sourcePolygon.value = null;
  };

  //   数据赋值
  const dataSouce = () => {
    modalForm.value[findIndex.value].coords = sourcePolygon.value
      ? sourcePolygon.value._opts.path
      : modalForm.value[findIndex.value].coords;
  };

  // 创建线编辑器
  const createPolyLine = (overlay) => {
    polylineEditor.value = new window.AMap.PolylineEditor(map.value, overlay);
    polylineEditor.value.open();

    polylineEditor.value.on("adjust", (e) => {
      console.log(e.target._opts.path);
      editPolyLine();
    });
    // 增加节点事件
    polylineEditor.value.on("addnode", (e) => {
      console.log(e.target._opts.path);
      editPolyLine();
    });
    // 删除节点事件
    polylineEditor.value.on("removenode", (e) => {
      console.log(e.target._opts.path);
      editPolyLine();
    });
  };

  // 线编辑和编辑的坐标处理
  const editPolyLine = () => {
    sourcePolygon.value = polylineEditor.value.getTarget();
    // 改变坐标
    dataSouce();
    console.log(sourcePolygon.value._opts.path);
  };

  // 保存线编辑
  const polyLineSave = () => {
    polylineEditor.value ? polylineEditor.value.close() : null;

    dataSouce();
    sourcePolygon.value = null;
  };

  // 恢复线编辑前的状态
  const polyLineReset = () => {
    polylineEditor.value ? polylineEditor.value.close() : null;
    sourcePolygon.value
      ? sourcePolygon.value.setPath(toRaw(targetPoly.value))
      : modalForm.value[findIndex.value].coords;

    dataSouce();
    sourcePolygon.value = null;
  };

  // 右键 绘制框 （编辑、详情）
  const editAndDetailInfoWindow = (position, e) => {
    var btn = `<div class="bot-btn">
    <div class="btn blue" id="edit-right-btn">编辑</div>
           <div class="btn" id="detail-right-btn">详情</div>
        </div>`;
    var infowindow = new window.AMap.InfoWindow({
      isCustom: true, //使用自定义窗体
      content: CreateEditAndDetail(btn),
      offset: new window.AMap.Pixel(16, -15),
      position: [position.lng, position.lat],
    });
    return infowindow;
  };
  return {
    initializeData,
    polygonReset,
    polygonSave,
    polyLineSave,
    polyLineReset,
  };
}
